cardDetailToggleButtonTemplate = require 'app/scripts/views/templates/card_detail_toggle_button'
{ track } = require '@trello/analytics'

module.exports.renderSubscribe = ->
  $subscribeSidebar = @$('.js-subscribe-sidebar-button')
  subscribed = @model.get('subscribed') || @model.get('badges')?.subscribed

  $subscribeSidebar.next('.toggle-button').remove()
  $subscribeSidebar.after cardDetailToggleButtonTemplate(
    isOn: subscribed
    text: 'watch'
    title: 'watch-the-card'
    icon: 'subscribe'
    selectorOn: 'js-unsubscribe'
    selectorOff: 'js-subscribe'
  )

  @$('.js-subscribed-indicator-header').toggleClass('hide', !subscribed)

  @

module.exports.subscribeToCard = (e) ->
  @model.subscribe(true)
  track("Card Detail", "Sidebar", "Subscribe", @model.trackProperty())
  @renderCommentSubmitAbility()
  false

module.exports.unsubscribeFromCard = (e) ->
  @model.subscribe(false)
  track("Card Detail", "Sidebar", "Unsubscribe", @model.trackProperty())
  @renderCommentSubmitAbility()
  false
